import { Names } from '@mode-switch/model';
import { Encoding, MarkTransform, MarkType } from '@mode-vegas/vegas';
import { ChartTypes } from '@mode/shared/contract-common';
import { EncodingHelpers } from '../..';
import { ChartTranslator } from '../chart-translator';
import {
  addMeasureNamesToBasicChannel,
  addMeasureValuesToSeries,
  clearTextChannel,
  removeEncField,
} from './translator-util';

export class GroupedBarTranslator implements ChartTranslator {
  private isHorizontal;

  constructor(isHorizontal: boolean) {
    this.isHorizontal = isHorizontal;
  }

  translateHighChartsToMuze(encoding: Encoding, format: Readonly<ChartTypes.ChartFormat>): Encoding {
    // Remove measure names from secondary axis
    const secondaryAxis = this.isHorizontal ? encoding.y : encoding.x;
    if (secondaryAxis[0]?.formula === Names.Key) {
      encoding = removeEncField(encoding, secondaryAxis[0]);
    }

    encoding = EncodingHelpers.updateMarkOptions(encoding, {
      type: MarkType.Bar,
      transform: MarkTransform.Group,
    }).encoding;

    encoding = clearTextChannel(encoding);
    if (encoding.marks.channel === '*' || !format.showValues) {
      return encoding;
    }
    return addMeasureValuesToSeries(encoding, 'text');
  }

  translateMuzeToHighCharts(encoding: Encoding): Encoding {
    // Clear the text channel
    encoding = clearTextChannel(encoding);
    // Put Measure Names back on secondary axis
    const secondaryAxis = this.isHorizontal ? encoding.y : encoding.x;
    if (secondaryAxis[0]?.formula !== Names.Key) {
      encoding = addMeasureNamesToBasicChannel(encoding, this.isHorizontal ? 'row' : 'column');
    }
    return encoding;
  }

  formatRequiresEncodingUpdate(
    oldFormat: Readonly<ChartTypes.ChartFormat>,
    newFormat: Readonly<ChartTypes.ChartFormat>
  ): boolean {
    return oldFormat.showValues !== newFormat.showValues;
  }
}
